import { useQuery } from "@tanstack/react-query";

import { assignmentsApi, type AssignmentListQuery } from "@/lib/api";

/**
 * Daftar penugasan untuk menu Assignment (tabel + filter).
 * Mutasi statusnya dipakai bersama menu Plan — lihat `useUpdateAssignmentStatus`
 * di `features/plan/useCoachPlan.ts` agar aturan cache tidak dobel.
 */
export function useCoachAssignments(query: AssignmentListQuery) {
    return useQuery({
        queryKey: ["coach-assignments", query],
        queryFn: ({ signal }) => assignmentsApi.get(query, signal),
    });
}
